import React from 'react';
import { ChartDoughnutSpacers,GraphicBox, DoughnutBoxLegendRight, DoughnutBoxLegendBottom, DoughnutBox, DoughnutBoxInside, DoughnutTextLine1, DoughnutTextLine2, DoughnutTextContainer, Dot, LegendBottom, LegendRight, LegendText, LegendContainer } from './styles';
import { Doughnut } from 'react-chartjs-2';
import { useDispatch } from 'react-redux';
import { ILegendItem } from './types';
import { Chart, PieController, ArcElement, Legend, Tooltip, Title } from 'chart.js';

Chart.register(PieController, ArcElement, Title, Legend, Tooltip);

export interface IProps {
    innerTextLine1?: string;
    innerTextLine2?: string;
    OuterRingData?: number[];
    InnerRingData?: number[];
    OuterRingColors?: string[];
    InnerRingColors?: string[];
    OuterRingDataSpacer?: number;
    InnerRingDataSpacer?: number;
    OuterRingCutOut?: number;
    InnerRingCutOut?: number;
    ShowLegend?: boolean;
    LegendItems?: ILegendItem[];
    OuterRingAnimation?: boolean;
    InnerRingAnimation?: boolean;
    LegendPosition?: string;
    ImageSpacer?: string;
}

const ChartDoughnut = React.memo((props: IProps) => {
    const outerRingCutOut = 89;
    const innerRingCutOut = 78;
    const dispatch = useDispatch();
    const OuterChartData = {
        datasets: [
            {
                data: solveEdgeCaseData(props.OuterRingData),
                backgroundColor: props.OuterRingColors,
                borderWidth: props.OuterRingDataSpacer!=undefined?props.OuterRingDataSpacer:2
            }
        ],
        options: {
            tooltips: {
                enable: false
            }
        }
    }

    const InnerChartData = {
        datasets: [
            {
                data: solveEdgeCaseData(props.InnerRingData),
                backgroundColor: props.InnerRingColors,
                borderWidth: props.InnerRingDataSpacer!=undefined?props.InnerRingDataSpacer:2
            }
        ],
        options: {
            tooltips: {
                enable: false
            }
        }
    }

    return (
        <DoughnutBox>
            <DoughnutBoxLegendBottom>
                <DoughnutBoxLegendRight>
                    <GraphicBox>
                        {
                            props.ImageSpacer && 
                            <ChartDoughnutSpacers>
                            <img src={props.ImageSpacer}></img>
                            </ChartDoughnutSpacers>
                        }
                        <Doughnut
                            data={OuterChartData}
                            options={{
                                cutout: calculateCutOut(outerRingCutOut, props.OuterRingCutOut,props.OuterRingDataSpacer),
                                plugins:{
                                    tooltip:{
                                        enabled: false
                                    }, 
                                    legend:{
                                        display: false
                                    } 
                                },
                                animation:{
                                    animateRotate: props.OuterRingAnimation ?? true
                                }
                            }}
                        />
                        <DoughnutBoxInside>
                            <Doughnut 
                                data={InnerChartData} 
                                options={{
                                    cutout: calculateCutOut(innerRingCutOut,props.InnerRingCutOut,props.InnerRingDataSpacer),
                                    plugins:{
                                        tooltip:{
                                            enabled: false
                                        }, 
                                        legend:{
                                            display: false
                                        } 
                                    },
                                    animation:{
                                        animateRotate: props.InnerRingAnimation ?? true
                                    }
                                }}
                            />
                            <DoughnutTextContainer>
                                <DoughnutTextLine1>
                                    {props.innerTextLine1?props.innerTextLine1:""}
                                </DoughnutTextLine1>
                                <DoughnutTextLine2>
                                    {props.innerTextLine2?props.innerTextLine2:""}
                                </DoughnutTextLine2>
                            </DoughnutTextContainer>
                        </DoughnutBoxInside>
                    </GraphicBox>                        
                    {
                        props.ShowLegend != undefined && props.ShowLegend && props.LegendItems != undefined && props.LegendPosition == 'RIGHT' &&
                        <LegendContainer>
                        <LegendRight>
                        {
                            props.LegendItems?.map((item) => renderLegendItem(item))
                        }
                        </LegendRight>
                        </LegendContainer>
                    }
                </DoughnutBoxLegendRight>
                {
                    props.ShowLegend != undefined && props.ShowLegend && props.LegendItems != undefined && (!props.LegendPosition || props.LegendPosition == 'BOTTOM') &&
                    <LegendContainer>
                    <LegendBottom>
                    {
                        props.LegendItems?.map((item) => renderLegendItem(item))
                    }
                    </LegendBottom>
                    </LegendContainer>
                }
            </DoughnutBoxLegendBottom>
        </DoughnutBox>
    );

    function solveEdgeCaseData(data?: number[])
    {
        if(data == undefined || data.length==0)
        {
            return data;
        }
        return data.map(item => Math.max(0, Math.min(100, item)));
    }

    function calculateCutOut(cutout: number,propsCutOut?: number,propsSpacer?: number)
    {
        if(propsCutOut!=undefined)
        {
            return propsCutOut;
        }
        let spacer=2;
        if(propsSpacer!=undefined)
        {
            spacer=propsSpacer;
        }
        return cutout-spacer;
    }

    function renderLegendItem(item: ILegendItem) {
        return (
            <tr>
                <td>
                    <Dot style={{backgroundColor:item.color}}/>
                </td>
                <td>
                    <LegendText>
                        {item.label}
                    </LegendText>
                </td>
            </tr>
        )
    }

}, (prevProps, nextProps) => {
        return true; // to avoid running the animation again at the component rerendering
});

export default ChartDoughnut;